import sendGetAction from './sendGetAction'

const deleteAction = ({ path, parameters }) => sendGetAction('DELETE', { path, parameters })

export default deleteAction
